// extracted by css-extract-rspack-plugin
export default {"lazyVideoSpinner":"_2a8b6663"};